import React, { useState } from 'react';
import axios from 'axios';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CheckInbox = ({ email, onBack }) => {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/resend-verification-public`, { email });
      toast.success(r.data.message);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Could not send the email');
    }
    setBusy(false);
  };

  return (
    <div className="text-center py-6" data-testid="check-inbox">
      <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
        <Mail className="w-8 h-8 text-primary" />
      </div>
      <h2 className="text-2xl font-bold text-foreground mb-2">Check your inbox</h2>
      <p className="text-muted-foreground">We sent a link to <span className="font-medium text-foreground" data-testid="check-inbox-email">{email}</span>.</p>
      <p className="text-muted-foreground mb-6">Click it to verify your email, and you'll be signed in right away.</p>
      <div className="flex flex-col gap-2 items-center">
        <Button variant="outline" onClick={resend} disabled={busy} data-testid="check-inbox-resend-btn">{busy ? 'Sending...' : 'Send the link again'}</Button>
        {onBack && <button type="button" onClick={onBack} className="text-sm text-muted-foreground hover:text-foreground" data-testid="check-inbox-back-btn">Back to sign in</button>}
      </div>
      <p className="text-xs text-muted-foreground mt-6">Can't find it? Check your spam or promotions folder.</p>
    </div>
  );
};
